import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { RouteRobots } from "../shared/seo/route-robots";
import { RouteError } from "../shared/ui/route-error";

interface AppRouteErrorProps {
  reloadPage?: () => void;
}

function reloadCurrentPage() {
  globalThis.location.reload();
}

export function AppRouteError({
  reloadPage = reloadCurrentPage,
}: AppRouteErrorProps) {
  const error = useRouteError();
  const status = isRouteErrorResponse(error)
    ? error.status
    : error instanceof Response
      ? error.status
      : null;
  return (
    <>
      <RouteRobots noIndex />
      <RouteError
        kind={status === 404 ? "not-found" : "unexpected"}
        onRetry={reloadPage}
      />
    </>
  );
}
